const COUNTRY_CODES = {
    // South America (CONMEBOL)
    'argentina': 'ar',
    'brasil': 'br', 'brazil': 'br',
    'chile': 'cl',
    'colombia': 'co',
    'uruguay': 'uy',
    'paraguay': 'py',
    'peru': 'pe', 'perú': 'pe',
    'ecuador': 'ec',
    'bolivia': 'bo',
    'venezuela': 've',
    
    // North/Central America (CONCACAF)
    'mexico': 'mx', 'méxico': 'mx',
    'usa': 'us', 'estados unidos': 'us',
    'canada': 'ca', 'canadá': 'ca',
    'costa rica': 'cr',
    'panama': 'pa', 'panamá': 'pa',
    'honduras': 'hn',
    'jamaica': 'jm',
    'el salvador': 'sv',

    // Europe (UEFA)
    'francia': 'fr', 'france': 'fr',
    'españa': 'es', 'spain': 'es',
    'inglaterra': 'gb-eng', 'england': 'gb-eng',
    'alemania': 'de', 'germany': 'de',
    'italia': 'it', 'italy': 'it',
    'portugal': 'pt',
    'paises bajos': 'nl', 'países bajos': 'nl', 'netherlands': 'nl',
    'belgica': 'be', 'bélgica': 'be', 'belgium': 'be',
    'croacia': 'hr', 'croatia': 'hr',
    'suiza': 'ch', 'switzerland': 'ch',
    'dinamarca': 'dk', 'denmark': 'dk',
    'suecia': 'se', 'sweden': 'se',
    'polonia': 'pl', 'poland': 'pl',
    'serbia': 'rs',
    'escocia': 'gb-sct', 'scotland': 'gb-sct',
    'gales': 'gb-wls', 'wales': 'gb-wls',

    // Asia (AFC)
    'japon': 'jp', 'japón': 'jp', 'japan': 'jp',
    'corea del sur': 'kr', 'south korea': 'kr',
    'arabia saudita': 'sa', 'saudi arabia': 'sa',
    'iran': 'ir', 'irán': 'ir',
    'australia': 'au',

    // Africa (CAF)
    'marruecos': 'ma', 'morocco': 'ma',
    'senegal': 'sn',
    'egipto': 'eg', 'egypt': 'eg',
    'camerun': 'cm', 'camerún': 'cm', 'cameroon': 'cm',
    'ghana': 'gh',
    'nigeria': 'ng',
    'costa de marfil': 'ci', 'ivory coast': 'ci',
};

export const getTeamLogoFallback = (teamName) => {
    if (!teamName) return null;
    const normalized = teamName.toLowerCase().trim();
    
    // Check if it's a known country for World Cup / International matches
    const code = COUNTRY_CODES[normalized];
    if (code) {
        // using flagcdn for high quality flag images
        return `https://flagcdn.com/w160/${code}.png`;
    }
    
    // If we wanted to add club teams, we could add another map here to standard logos.
    // Return null if no match, so the UI fallback (circle with first letter) triggers.
    return null;
};
